export const Eleven = 'R';